module.exports = __webpack_public_path__ + "img/3.890923d0.svg";